import styled, { css, DefaultTheme } from 'styled-components';
import { lighten } from 'polished';

type WrapperProps = {
  soon: boolean;
  platform: 'ios' | 'android';
};

const WrapperModifiers = {
  soon: () => css`
    &::before {
      content: '';
      position: absolute;
      background-image: url('/assets/svg/coming-soon.svg');
      background-repeat: no-repeat;
      top: -18px;
      left: -16px;
      width: 79px;
      height: 63px;
    }

    cursor: initial;
  `,
  ios: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.storesGray};
  `,
  android: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.neutralSilver5};
    border: 1px solid ${lighten(0.5, theme.colors.globalBlack100)};
  `,
};

export const Wrapper = styled.a<WrapperProps>`
  ${({ theme, soon, platform }) => css`
    border-radius: 16px;
    min-width: 177px;
    padding: 12px 16px;
    text-decoration: none;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    position: relative;

    ${soon && WrapperModifiers.soon()}
    ${platform && WrapperModifiers[platform](theme)}
  `}
`;
